'use-strict'

import configureStore from '../../redux/store'

export default storeName => ({
    data: configureStore.store.getState()[storeName],
    dispatch: configureStore.store.dispatch
})